import React from "react";
import Popup from "reactjs-popup";

class InfoPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: this.props.openInfoPopup,
    };
    this.closeInfoModal = this.closeInfoModal.bind(this);
  }

  closeInfoModal() {
    this.props.onChange(false);
  }

  // Helper function to convert camelCase or snake_case to readable label
  formatLabel(key) {
    return key
      .replace(/_/g, " ") // snake_case to space
      .replace(/([a-z])([A-Z])/g, "$1 $2") // camelCase to space
      .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize
  }

  render() {
    const openInfoPopup = this.props.openInfoPopup.open;
    const message = this.props.openInfoPopup.data || {};

    return (
      <div>
        <Popup
          open={openInfoPopup}
          onClose={this.closeInfoModal}
          closeOnDocumentClick
        >
          <div className="card">
            <div className="card-header">
              <div className="card-options">
                <a
                  className="card-options-remove cursorPointer"
                  onClick={this.closeInfoModal}
                >
                  <i className="fe fe-x" />
                </a>
              </div>
            </div>
            <div className="card-body aligncenter">
              {Object.entries(message)
                .filter(([_, value]) => value && value.toString().trim() !== "")
                .map(([key, value]) => (
                  <div key={key}>
                    <strong>{this.formatLabel(key)}:</strong> {value}
                  </div>
                ))}
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}

export default InfoPopup;
